import React from "react";
import hilightLinkMCSLink from "./hilightLinkMCSLink";
import styles from "./styles.module.css";

const TweetEmbed = ({ avatar, name, nick, text, date, likes, isBacklight }) => {
  return (
    <div
      style={{ backgroundColor: !isBacklight && "white" }}
      className={styles.embed}
    >
      <div className={styles.embedHeader}>
        <div className={styles.embedAvatarWrapper}>
          <img className={styles.twitterAvatar} src={`https://${avatar}`} />
          <div className={styles.nickWrapper}>
            <span style={{ fontWeight: "bold" }}>{name}</span>
            <br />
            <span>{`@${nick} · `}</span>
            <span style={{ color: "rgb(0, 111, 214)", fontWeight: "bold" }}>Follow</span>
          </div>
        </div>
        <svg>
          <path
            fill={"rgb(29, 155, 240)"}
            viewBox="0 0 24 24"
            d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z"
          ></path>
        </svg>
      </div>
      <div
        className={styles.tweetText}
        dangerouslySetInnerHTML={{ __html: hilightLinkMCSLink(text) }}
      />
      <span className={styles.timeDate}>{date}</span>
      <div className={styles.divider} />
      <div className={styles.controllButtons}>
        <svg style={{ marginRight: "50px" }}>
          <path
            fill={"rgb(83, 100, 113)"}
            viewBox="0 0 24 24"
            d="M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.034 11.596 8.55 11.658 1.518-.062 8.55-5.917 8.55-11.658 0-2.267-1.823-4.255-3.903-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.014-.03-1.425-2.965-3.954-2.965z"
          ></path>
        </svg>
        {likes > 0 && <span className={styles.likesCounter}>{likes}</span>}
        <svg style={{ marginRight: "10px" }}>
          <path
            fill={"rgb(83, 100, 113)"}
            viewBox="0 0 24 24"
            d="M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.044.286.12.403.142.225.384.347.632.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.367-3.43-7.787-7.8-7.788zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.335-.75-.75-.75h-.396c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z"
          ></path>
        </svg>
        <span style={{ marginRight: "20px" }}>Replay</span>
        <svg style={{ marginRight: "10px" }}>
          <path
            fill={"rgb(83, 100, 113)"}
            viewBox="0 0 24 24"
            d="M11.96 14.945c-.067 0-.136-.01-.203-.027-1.13-.318-2.097-.986-2.795-1.932-.832-1.125-1.176-2.508-.968-3.893s.942-2.605 2.068-3.438l3.53-2.608c2.322-1.716 5.61-1.224 7.33 1.1.83 1.127 1.175 2.51.967 3.895s-.943 2.605-2.07 3.438l-1.48 1.094c-.333.246-.804.175-1.05-.158-.246-.334-.176-.804.158-1.05l1.48-1.095c.803-.592 1.327-1.463 1.476-2.45.148-.988-.098-1.975-.69-2.778-1.225-1.656-3.572-2.01-5.23-.784l-3.53 2.608c-.802.593-1.326 1.464-1.475 2.45-.15.99.097 1.975.69 2.778.498.675 1.187 1.15 1.992 1.377.4.114.633.528.52.928-.092.33-.394.547-.722.547z"
          ></path>
          <path
            fill={"rgb(83, 100, 113)"}
            viewBox="0 0 24 24"
            d="M7.27 22.054c-1.61 0-3.197-.735-4.225-2.125-.832-1.127-1.176-2.51-.968-3.894s.943-2.605 2.07-3.438l1.478-1.094c.334-.245.805-.175 1.05.158s.177.804-.157 1.05l-1.48 1.095c-.803.593-1.326 1.464-1.475 2.45-.148.99.097 1.975.69 2.778 1.225 1.657 3.57 2.01 5.23.785l3.528-2.608c1.658-1.225 2.01-3.57.785-5.23-.498-.674-1.187-1.15-1.992-1.376-.4-.113-.633-.527-.52-.927.112-.4.528-.63.926-.522 1.13.318 2.096.986 2.794 1.932 1.717 2.324 1.224 5.612-1.1 7.33l-3.53 2.608c-.933.693-2.023 1.026-3.105 1.026z"
          ></path>
        </svg>
        <span>Copy link</span>
      </div>
    </div>
  );
};

export default TweetEmbed;
